import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import { Shield, Lock, Server, Key, Eye, FileCheck } from "lucide-react";

const SecurityPage = () => {
  const measures = [
    {
      icon: Lock,
      title: "Veri Şifreleme",
      desc: "Tüm veriler hem aktarım sırasında (TLS 1.3) hem de bekleme durumunda (AES-256) şifrelenir. Ses kayıtları, transkriptler ve müşteri verileri uçtan uca korunur.",
    },
    {
      icon: Server,
      title: "Altyapı Güvenliği",
      desc: "Sunucularımız Türkiye'deki ISO 27001 sertifikalı veri merkezlerinde barındırılır. İsteğe bağlı olarak AB bölgesinde veri saklama seçeneği sunuyoruz.",
    },
    {
      icon: Key,
      title: "Erişim Kontrolü",
      desc: "Rol tabanlı erişim kontrolü (RBAC), iki faktörlü kimlik doğrulama (2FA) ve IP kısıtlama ile hesap güvenliğiniz sağlanır.",
    },
    {
      icon: Eye,
      title: "Sürekli İzleme",
      desc: "7/24 güvenlik izleme, otomatik tehdit tespiti ve anomali uyarı sistemleri ile platformumuz sürekli denetim altındadır.",
    },
    {
      icon: Shield,
      title: "Penetrasyon Testleri",
      desc: "Bağımsız güvenlik firmaları tarafından yılda en az 2 kez kapsamlı sızma testi gerçekleştirilir. Bulgular en geç 30 gün içinde kapatılır.",
    },
    {
      icon: FileCheck,
      title: "KVKK ve GDPR Uyumu",
      desc: "Kişisel verilerin işlenmesi KVKK ve GDPR ile tam uyumludur. Veri işleme envanteri, aydınlatma metinleri ve açık rıza mekanizmaları aktiftir.",
    },
  ];

  const hero = (
    <PageHero
      eyebrow="Güvenlik"
      title="Güvenlik Taahhüdümüz"
      subtitle="Verilerinizin güvenliği bizim önceliğimizdir. ISO 27001 uyumlu altyapımız ve uçtan uca şifreleme ile verileriniz emin ellerde."
    />
  );

  return (
    <PageLayout hero={hero}>
      <SectionReveal>
        <section className="py-16 px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-[28px] font-bold mb-10 text-center" style={{ color: "var(--fg)" }}>Güvenlik Önlemlerimiz</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
              {measures.map((m) => (
                <div
                  key={m.title}
                  className="p-6 rounded-2xl transition-colors duration-200"
                  style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}
                >
                  <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4" style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}>
                    <m.icon size={22} />
                  </div>
                  <h3 className="text-[16px] font-semibold mb-2" style={{ color: "var(--fg)" }}>{m.title}</h3>
                  <p className="text-[13.5px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.82 }}>{m.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-3xl mx-auto">
            <h2 className="text-[22px] font-bold mb-6" style={{ color: "var(--fg)" }}>Güvenlik Açığı Bildirimi</h2>
            <p className="text-[14.5px] leading-relaxed mb-6" style={{ color: "var(--fg)", opacity: 0.85 }}>
              Verasist platformunda bir güvenlik açığı keşfettiyseniz, lütfen sorumlu açıklama politikamız kapsamında bize bildirin. Bildiriminizi 72 saat içinde değerlendirip size dönüş yapacağız.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="mailto:security@verasist.ai"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-[14px] transition-all duration-200"
                style={{ background: "var(--brand-navy)", color: "#fff" }}
              >
                <Shield size={16} /> security@verasist.ai
              </a>
              <span className="text-[13px] self-center" style={{ color: "var(--muted)" }}>
                PGP Key: 8F3A 21B7 C9D4 E601 5A2F 3B8C 1D47 9E62 F5A0 7C33
              </span>
            </div>
          </div>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default SecurityPage;
